// extracted by mini-css-extract-plugin
module.exports = {"baseTextClass":"BaseText_baseTextClass__3TvpW"};